// 销售订单 tableColumns
export default {
  props: {

  },
  data() {
    return {
      countdownTimer: null, // 倒计时定时器
      currentTime: Date.now(), // 当前时间，用于触发响应式更新
      orderTableColumns: [
        { id: -2, type: 'selection', width: 29, show: true, align: 'center', fixed: 'left', noSet: true, order: -2 },
        // { id: -1, type: 'index', label: '序号', width: 40, show: true, fixed: 'left', noSet: true, order: -1 },
        { id: -1,  prop:'serialNumber', label: '序号', width: 40, align: 'center', show: true, fixed: 'left', noSet: true, order: -1 },
        {
          id: 1, label: '五域订单号', width: 100, align: 'left',show: true,
          freeze: false, className:'nowrap primary',
          render: (h, scope) => {
            return (
              <span>
                <div class='text'  onClick={() => this.onCopy(scope.row.orderNo)}>
                  {scope.row.orderNo }
                </div>
                {/* 售后状态（0无售后，1售后进行中，2售后完成 */}
                {scope.row.afterSalesStatus == 1 && <div class='order-tag'>售后中</div>}
                {/* 第三方平台对应同步失败状态 0：正常，1：上，2：下，3：上和下
                {(scope.row.thirdPartyExceptionStatus == 1 || scope.row.thirdPartyExceptionStatus == 3) && <span class='order-tag'>上</span>}
                {(scope.row.thirdPartyExceptionStatus == 2 || scope.row.thirdPartyExceptionStatus == 3) && <span class='order-tag'>上</span>}
                {(scope.row.thirdPartyExceptionStatus == 1 || scope.row.thirdPartyExceptionStatus == 3) ? 
                  <span class='i-circle-sync' onClick={(e) => this.onSyncOrder(scope.row,e)}>同</span> :
                  <span class='i-circle-detail' onClick={(e) => this.onDetail(scope.row,e)}>详</span>
                } */}
                <span class='i-circle-detail' onClick={(e) => this.onDetail(scope.row,e)}>详</span>
              </span>
            )
          }
        },
        { id: 2, label: '订单状态', width: 100, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div>
                <div class={`order-status-${scope.row.omsStatus}`}>
                  <div class='text'>{scope.row.omsStatusLabel}</div>
                  {scope.row.exceptionList && scope.row.exceptionList.map(item => (
                    <div class='order-status-tag'>{item.exceptionName}</div>
                  ))}
                  <div class='bg'></div>
                </div>
              </div>
            )
          }
         },
        { id: 3, label: '标签',width: 180, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div class='flex'>
                {scope.row.tags && scope.row.tags.map(item => (
                  item.isFlagTag ? 
                    <span class={`tag-no tag-${item.tagId}`}></span> : 
                    item.tagType==3 ? 
                      (() => {
                        // 检查是否过期，如果过期则不显示整个标签
                        if (!item.expiredTime) return null;
                        const now = this.currentTime;
                        const expiredTime = new Date(item.expiredTime).getTime();
                        const remainingTime = expiredTime - now;
                        if (remainingTime <= 0) return null;
                        
                        return <span class='tag-text tag-red'>{item.tagName} {this.countDown(item)}</span>;
                      })() : 
                      <span class='tag-text tag-black'>{item.tagName}</span>
                    
                ))}
              </div>
            )
          }
        },
        { id: 4, label: '外部订单号',width: 100, align: 'left', show: true, freeze: false, className:'nowrap',
          render: (h, scope) => {
            return (
              <span onClick={() => this.onCopy(scope.row.outOrderNo)}>
               {scope.row.outOrderNo }
              </span>
            )
          }
        },
        { id: 5, label: '商品信息', width: 114, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div class='flex goods-info' onClick={() => this.onGoodsInfo(scope.row)}>
                {scope.row.goodsList && scope.row.goodsList.map((goods, index) => (
                  <div class='pic hand' key={index} title={goods.goodsName}>
                    <el-image src={goods.goodsSkuPic} width='28' height='28' fit="cover">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    {/* <img src={goods.goodsSkuPic} width='28' height='28' /> */}
                    <span class='count'>{goods.quantity}</span>
                  </div>
                ))}
              </div>
            )
          }
        },
        { id: 6, label: '客户', width: 132, align: 'left', show: true, freeze: false, className:'nowrap',
          render: (h, scope) => {
            return (
              <span>
                {scope.row.userName + '  ' +scope.row.postContact}
              </span>
            )
          }
         },
        { id: 7, label: '买家留言', width: 86, align: 'left', show: true, freeze: false, className:'nowrap gary',
          render: (h, scope) => {
            return (
              <span title={scope.row.buyerMessage}>
                {scope.row.buyerMessage}
              </span>
            )
          }
        },
        { id: 8, label: '收货信息', width: 232, align: 'left', show: true, freeze: false, className:'nowrap',
          render: (h, scope) => {
            let icon,address
            if (scope.row.deliveryType == 2) {
              icon = <span class='i-self-pickup'>自提</span>
              address = scope.row.postName + " " +scope.row.postContact + " " + scope.row.fullAddress
            }else{
              address = scope.row.postName + " " +scope.row.postContact + " " + scope.row.fullAddress
            }
            return (
              <span title={address}>
                {icon}{address}
                {/* <span class='i-circle-edit' onClick={() => this.onEditAddress(scope.row)}>改</span> */}
              </span>
            )
          }
         },
        { id: 9, label: '商品数量', prop:'quantity', width: 74, align: 'left', show: true, freeze: false},
        { id: 10, label: '金额', width: 232, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span >
                {`总价:￥${scope.row.totalAmount + '  '}  
                已收:￥${scope.row.receivedAmount + '  '}
                代收:￥${scope.row.expressAmount + '  '}  
                运费:￥${scope.row.freightAmount}`}
              </span>
            )
          }
         },
        { id: 11, label: '店铺信息',  width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span>
                {scope.row.shopInfo ? (scope.row.shopInfo.shopName ||'') + (scope.row.shopInfo.shopId ? `(${scope.row.shopInfo.shopId})` : '') : ''}
              </span>
            )
          }
        },
        { id: 12, label: '商家备注', width: 86, align: 'left', show: true, freeze: false,className:'nowrap gary',
          render: (h, scope) => {
            return (
              <span title={scope.row.merchantRemark}>
                {scope.row.merchantRemark }
              </span>
            )
          }
        },
        { id: 13, label: '重量', prop:'weight', width: 74, align: 'left', show: true, freeze: false},
        { id: 14, label: '体积', prop:'volume', width: 74, align: 'left', show: true, freeze: false},
        { id: 15, label: '赠品信息', width: 78, align: 'left', show: true, freeze: false, className:'nowrap',
          render: (h, scope) => {
            let giftInfo = scope.row.giftInfo && scope.row.giftInfo.giftInfoDetail && scope.row.giftInfo.giftInfoDetail.length>0 && scope.row.giftInfo.giftInfoDetail
            giftInfo = giftInfo && String(giftInfo)
            return giftInfo && (
              <span title={giftInfo}>
                {giftInfo }
              </span>
            )
          }
        },
        { id: 16, label: '订单分类', prop:'orderGenerateTypeName', width: 62, align: 'left', show: true, freeze: false},
        { id: 17, label: '订单来源', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.orderOriginName}>
                {scope.row.orderOriginName }
              </span>
            )
          }
        },
        { id: 18, label: '第三方平台', prop:'platformName', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.platformName}>
                {scope.row.platformName }
              </span>
            )
          }},
        { id: 19, label: '订单类型', prop:'orderTypeName', width: 86, align: 'left', show: true, freeze: false},
        { id: 20, label: '客户下单时间', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.submitTime}>
                {scope.row.submitTime }
              </span>
            )
          }
        },
        { id: 21, label: '客户付款时间', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.payTime}>
                {scope.row.payTime }
              </span>
            )
          }
        },
        { id: 22, label: '客户支付方式', width: 86, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div>
                {scope.row.payTypeName }
              </div>
            )
          }
        },
        { id: 23, label: '支付流水号', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.transactionId}>
                {scope.row.transactionId }
              </span>
            )
          }
        },
        { id: 24, label: '是否到付', width: 62, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div>
                {scope.row.codFlag ? '是' : '否'}
              </div>
            )
          }
        },
        { id: 25, label: '发票信息', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
//发票抬头：长度不超100个字符；
// 税号；长度不超过18个字符；
// 开户银行：长度不超过50个字符；
// 开户账号：长度不超过20个字符；
// 企业地址：长度不超过100个字符，超出已省略号隐藏；
// 企业电话：长度不超过12位；
// 邮箱：长度不超过50个字符；           
            let text
            if (scope.row.invoiceInfo) {
              if (scope.row.invoiceInfo.invoiceTitleType === 1) { 
                text = scope.row.invoiceInfo.invoiceTitle + ' ' + scope.row.invoiceInfo.taxpayerNumber 
              }else{
                text = scope.row.invoiceInfo.invoiceTitle
              }
            } else {
              text = ''
            }
            return (
              <span title={text}>
                {text}
              </span>
            )
          }
        },
        { id: 26, label: '内购价', width: 62, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div>
                {scope.row.purchaseFlag? '是' : '否' }
              </div>
            )
          }
        },
        { id: 27, label: '客服部门', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.sysUserOrg}>
                {scope.row.sysUserOrg}
              </span>
            )
          }
        },
        { id: 28, label: '跟进客服', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.sysUserName}>
                {scope.row.sysUserName}
              </span>
            )
          }
        },
        { id: 29, label: '资源来源', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.resourceSource}>
                {scope.row.resourceSource}
              </span>
            )
          }
        },
        { id: 30, label: '客服订单审核状态', width: 110, align: 'left', show: true, freeze: false,
          // '统一审核状态: 1-待私域审核, 2-私域审核通过, 3-私域审核不通过, 4-待公域审核, 5-公域审核通过',
          render: (h, scope) => {
            let status = scope.row.auditStatus
            const statusMap = {
              1: {text: '待审核', class: 'blue'},
              2: {text: '审核通过', class: 'default'},
              3: {text: '审核不通过', class: 'red'},
              4: {text: '待审核', class: 'blue'},
              5: {text: '审核通过', class: 'default'}
            };
            return (
              <div class={`text-${ status && statusMap[status] && statusMap[status].class}`}>
                { status>0 && statusMap[status].text}
                { status>0 && <span class='i-circle-detail' onClick={() => this.onAuditRecord(scope.row)}>详</span> }
              </div>
            )
          }
        },
        { id: 31, label: '客服订单审核人及备注', width: 138, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let text = ''
            if (scope.row.auditInfo && scope.row.auditInfo.auditorName) { 
              text = scope.row.auditInfo.auditorName +'  '+  scope.row.auditInfo.auditRemark
            }
            return (
              <span title={text}>
                {text}
              </span>
            )
          }
        },
        { id: 32, label: '客服备注', width: 138, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let canSet = scope.row.canEditServiceRemark
            return (
              <span title={scope.row.serviceRemark}>
                {scope.row.serviceRemark }
                { canSet && <span class='i-circle-edit' onClick={() => this.onSetRemark(scope.row)}>改</span>}
              </span>
            )
          }
        },
        { id: 33, label: '客服下单时间', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.serviceOrderTime}>
                {scope.row.serviceOrderTime }
              </span>
            )
          }
        },
        { id: 34, label: '提成类型', width: 62, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.bonusTypeName}>
                {scope.row.bonusTypeName}
              </span>
            )
          }
        },
        { id: 35, label: '提成审核状态', width: 86, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            // 0-申诉审核中，1-撤销申诉，2-审核通过，3-申诉驳回，4-被改提成
            let status = scope.row.bonusReviewStatus;
            let statusText = scope.row.bonusReviewStatusName;
            const statusMap = {
              0: {text: '申诉审核中', class: 'blue'},
              1: {text: '撤销申诉', class: 'gray'},
              2: {text: '审核通过', class: 'default'},
              3: {text: '申诉驳回', class: 'red'},
              4: {text: '被改提成', class: 'red'},
            };
            return (
              <div class={`text-${ statusText && statusMap[status].class}`}>
                {statusText}
                {statusText && <span class='i-circle-detail' onClick={() => this.onAppealRecord(scope.row)}>详</span>}
              </div>
            )
          }
        },
        { id: 36, label: '提成申诉人及备注', width: 110, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let text = ''
            if (scope.row.bonusApplyInfo && scope.row.bonusApplyInfo.applyName) { 
              text = scope.row.bonusApplyInfo.applyName +'  '+  scope.row.bonusApplyInfo.reason
            }
            return (
              <span title={text}>
                {text}
              </span>
            )
          }
        },
        { id: 37, label: '提成审批人及备注', width: 110, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let text = ''
            if (scope.row.bonusApprovalInfo && scope.row.bonusApprovalInfo.auditUserName) { 
              text = scope.row.bonusApprovalInfo.auditUserName +'  '+  scope.row.bonusApprovalInfo.auditRemarks
            }
            return (
              <span title={text}>
                {text}
              </span>
            )
          }
        },
        { id: 38, label: '提成修改人及备注', width: 110, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let text = ''
            if (scope.row.bonusModifyInfo && scope.row.bonusModifyInfo.modifyName) { 
              text = scope.row.bonusModifyInfo.modifyName +'  '+  scope.row.bonusModifyInfo.modifyReason
            }
            return (
              <span title={text}>
                {text}
              </span>
            )
          }
        },
        { id: 39, label: '确认修改', width: 62, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            return (
              <div>
                {scope.row.confirmModify}
              </div>
            )
          }
        },
        { id: 40, label: '最晚发货时间', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.latestDeliveryTime}>
                {scope.row.latestDeliveryTime}
              </span>
            )
          }
        },
        { id: 41, label: '发货时间', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span title={scope.row.postDeliverTime}>
                {scope.row.postDeliverTime }
              </span>
            )
          }
        },
        { id: 42, label: '发货仓', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
           render: (h, scope) => {
            return (
              <span title={scope.row.warehouseName}>
                {scope.row.warehouseName}
              </span>
            )
          }
        },
        { id: 43, label: '指定快递', width: 86, align: 'left', show: true, freeze: false,
           render: (h, scope) => {
            let  canSet = scope.row.canSetLogistics
            return (
              <div>
                {scope.row.specifiedLogistics}
                 { canSet && <span class='i-circle-set' onClick={(e) => this.onSetExpress(scope.row)}>设</span>}
              </div>
            )
          }
        },
        { id: 44, label: '指定发货日期', width: 100, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            return (
              <span>
                {scope.row.appointTime ? scope.row.appointTime.substring(0, 10) : ''}
              </span>
            )
          }
        },
        { id: 45, label: '发货快递公司', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
           render: (h, scope) => {
            return (
              <span title={scope.row.deliveryCompanies}>
                {scope.row.deliveryCompanies }
              </span>
            )
          }
        },
        { id: 46, label: '物流单号', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let logisticsNumbers = String(scope.row.logisticsNumbers)
            return (
              <span title={logisticsNumbers}  onClick={() => this.onCopy(logisticsNumbers)}>
                {logisticsNumbers}
                {logisticsNumbers && <span class='i-circle-detail' onClick={(e) => this.onLogistics(scope.row,e)}>详</span>}
              </span>
            )
          }
        },
        { id: 47, label: '售后商品', width: 78, align: 'left', show: true, freeze: false,
          render: (h, scope) => {
            let hasGoods = scope.row.afterSalesGoods && scope.row.afterSalesGoods.length > 0
            return (
              <div class='flex goods-info' onClick={() => this.onGoodsAfter(scope.row)}>
                {hasGoods &&  scope.row.afterSalesGoods.map((goods, index) => (
                  <div class='pic hand' key={index} title={goods.goodsName}>
                    <el-image src={goods.goodsSkuPic} width='28' height='28'  fit="cover">
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    {/* <img src={goods.goodsSkuPic} width='28' height='28' /> */}
                    <span class='count'>{goods.quantity}</span>
                  </div>
                ))}
                {hasGoods && <span class='i-circle-detail' onClick={(e) => this.onAfterSale(scope.row,e)}>详</span>}
              </div>
            )
          }
        },
        { id: 48, label: '售后备注', width: 86, align: 'left', show: true, freeze: false,className:'nowrap',
          render: (h, scope) => {
            let canSet = scope.row.canEditAfterSalesRemark
            let remark = ''
            if (scope.row.afterSalesInfoList && scope.row.afterSalesInfoList.length>0) {
              scope.row.afterSalesInfoList.forEach(e=>{
                if (e.remark) {
                  remark += e.remark+';'
                }
              })
            }
            return (
              <span title={remark}>
                {remark }
                {canSet && <span class='i-circle-edit' onClick={(e) => this.onSetSalesRemark(scope.row,e)}>改</span>}
              </span>
            )
          }
        },
         { id: 49, label: '配送方式', width: 76, align: 'left', show: true, freeze: false,className:'nowrap',
           render: (h, scope) => {
            return (
              <span>
                {scope.row.deliveryTypeLabel }
              </span>
            )
          }
        },

      ],
  
    }
},
methods: {
    countDown(item) {
      // 如果没有过期时间，返回空字符串
      if (!item.expiredTime) {
        return '';
      }

      // 使用响应式的currentTime来触发更新
      const now = this.currentTime;
      const expiredTime = new Date(item.expiredTime).getTime();
      const remainingTime = expiredTime - now;

      // 如果已经过期，返回"已过期"
      if (remainingTime <= 0) {
        return '已过期';
      }

      // 计算剩余天数
      const days = Math.floor(remainingTime / (24 * 60 * 60 * 1000));
      
      // 如果大于等于24小时，返回天数
      if (days >= 1) {
        return `${days}天`;
      }

      // 小于24小时，计算小时、分钟、秒
      const hours = Math.floor(remainingTime / (60 * 60 * 1000));
      const minutes = Math.floor((remainingTime % (60 * 60 * 1000)) / (60 * 1000));
      const seconds = Math.floor((remainingTime % (60 * 1000)) / 1000);

      // 格式化显示 hh:mm:ss
      const formatTime = (num) => num.toString().padStart(2, '0');
      return `${formatTime(hours)}:${formatTime(minutes)}:${formatTime(seconds)}`;
    },

    // 启动倒计时定时器
    startCountdownTimer() {
      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      
      // 每秒更新一次当前时间，触发响应式更新
      this.countdownTimer = setInterval(() => {
        this.currentTime = Date.now();
      }, 1000);
    },

    // 停止倒计时定时器
    stopCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
  },
  
  // 生命周期钩子
  mounted() {
    // 组件挂载后启动倒计时定时器
    this.startCountdownTimer();
  },
  
  beforeDestroy() {
    // 组件销毁前停止倒计时定时器
    this.stopCountdownTimer();
  }
}
